<template>
        <div v-if="!is_playing">
            
            <img alt="Vue logo" src="../assets/logo.png">

            <div style="display: block;">
                <div>
                    <label for="game_id">Game ID: </label>
                    <input name="game_id" type="text" v-model="gameId" />
                </div>
                <div>
                    <label for="player_name">Player Name: </label>
                    <input name="player_name" type="text" v-model="playerName" />
                </div>
                <button @click="joinGame">Join</button>
                <h2 @click="hideError" v-if="error_message">{{ error_message}}</h2>
            </div>
        </div>
        <div v-else-if="current_question != null">
            <h1>{{ current_question.question }}</H1>

            <div v-for="(option, index) in current_question.options" :key="index">
                <button class="option" @click="answerQuestion(index)">{{ option }}</button>
            </div>

        </div>
        <div v-else>
            <h1>Waiting to start</h1>
        </div>
</template>

<script>

import io from 'socket.io-client';

export default {
  name: 'PlayerPage',
  props: {
  },
  data() {
    return {
        is_playing: false,
        gameId: "",
        playerName: "",
        playerToken: "",
        game_info: null,
        socket: null,
        current_question: null,
        error_message: null
    };
  },
  methods: {
    connectToServer() {
      this.socket = io(`${process.env.VUE_APP_SERVER_URL}`, { transports : ['websocket'] });

      this.socket.on('connect', () => {
          // Auto rejoin the same game after transient network reconnects.
          if (this.gameId && this.playerName && this.playerToken) {
              this.joinGame();
          }
      });

      this.socket.on('question', (question) => {
          this.current_question = question;
      });

      this.socket.on('gameEnd', () => {
          this.current_question = null;
          this.game_info = null;
          this.is_playing = false;
      });

        this.socket.on('gameJoined', (gameId) => {
            this.game_info = {"game_id" : gameId};
            this.is_playing = true;
        });

        this.socket.on('error', (message) => {
            this.error_message = message;
        });
    },
    joinGame() {
        if (this.socket == null) {
            console.log("Server not connected");
            return;
        }

        if (!this.gameId || !this.playerName) return;

        this.socket.emit('joinGame', {
            "game_id": this.gameId,
            "name": this.playerName,
            "player_token": this.playerToken,
        });
    },
    ensurePlayerToken() {
        const tokenKey = 'questalot_player_token';
        const existingToken = localStorage.getItem(tokenKey);

        if (existingToken) {
            this.playerToken = existingToken;
            return;
        }

        const generatedToken = `${Date.now()}-${Math.random().toString(36).substring(2, 12)}`;
        this.playerToken = generatedToken;
        localStorage.setItem(tokenKey, generatedToken);
    },
    answerQuestion(choice) {
        if (this.socket == null) {
            console.log("Server not connected");
            return;
        }

        this.socket.emit('answerQuestion', {"gameId": this.game_info.game_id, "answer": choice});
        this.current_question.question = "Good luck";
        this.current_question.options = [];
    },
    hideError() {
        this.error_message = null;
    }
  },
  mounted() {
    this.ensurePlayerToken();
    this.connectToServer();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.option {
    display: block;
    width: calc(100% - 2em);
    max-width: 720px;
    margin: 1em auto;
    background-color: #0065A4;
    color: #FFFFFF;
    font-size: 2.5em;
    padding: 20px 40px;
    border: 0;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    text-align: center;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.option:hover {
    background-color: #00507f;
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.24);
}

.option:active {
    transform: translateY(0);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.timer {
    text-align: center; 
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    border-radius: 10px; 
    padding: 20px 40px; 
    background-color: rgba(255, 0, 0, 1);    
    color: #FFFFFF; 
    font-size: 2.5em; 
    margin: 2em;
}
</style>
